import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, RecordsTable, USER_PERMISSIONS } from 'dyl-components';

import LeadsHeader from './Header';
import LeadsRow from './LeadsRow';
import AddLeadModal from 'shared/modals/AddLeadModal';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import SequenceModal from 'shared/modals/SequenceModal';
import { CustomGroupUtils } from 'utils';
import customFieldsGroupActions from 'actions/custom_fields_group';
import QuoteBuilderProvider from 'shared/context/QuoteBuilderProvider';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';
const LeadsTable = ({ onFilter, isColumnHidden, onPageChange, filterQueryParameters }) => {
    const [params] = useSearchParams();

    const { count = 0, leads = [], isReadingLeads } = useSelector(state => state.leads);
    const { isSkipingCallback } = useSelector(state => state.workflows);
    const [isAddLeadModalOpen, setIsAddLeadModalOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);
    const [modalRef, setModalRef] = useState(null);
    const onOpenAddLeadModal = () => {
        setIsAddLeadModalOpen(true);
    }
    const isLeadConnectFilter = params.get('lead_connect') === 'true';
    const onCloseAddLeadModal = () => {
        setIsAddLeadModalOpen(false);
    }
    const dispatch = useDispatch();
    const { group } = useSelector(state => ({
        group: state.custom_fields_group.page_standard_group,
    }));

    const groupFields = group?.fields?.data || [];
    const priority_options = CustomGroupUtils.getFieldOptions(groupFields, 'priority');
    const rating_options = CustomGroupUtils.getFieldOptions(groupFields, 'rating');
    useEffect(() => {
        dispatch(customFieldsGroupActions.getPageStandardGroup({ group_name: 'lead' }));
    }, [dispatch])

    const [leadBeingConverted, setLeadBeingConverted] = useState(null);
    
    const onSelectLeadForConversion = (id) => {
        setLeadBeingConverted(id);
    }

    const detailsOfLeadBeingConverted = leads.find(lead => lead.pipeline_id === leadBeingConverted);
    return (
        <React.Fragment>

            <QuoteBuilderProvider>
                <RecordsTable
                    tableBodyClassName='ModulesListTable'
                    isTableLoading={isReadingLeads || isSkipingCallback}
                    isSearchResultEmpty={count === 0 && (params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
                    isTableEmpty={count === 0 && !(params.get('search') || params.get('start') || params.get('end') || params.get('account_type') || params.get('owned_by'))}
                    TableHeader={<LeadsHeader isColumnHidden={isColumnHidden} onFilter={onFilter} />}
                    TableRows={leads.map(lead => (
                        <LeadsRow
                            key={lead.pipeline_id}
                            lead={{...lead, contact_id: lead?.contact?.id}}
                            isColumnHidden={isColumnHidden}
                            filterQueryParameters={filterQueryParameters}
                            setSelectedLead={setSelectedLead}
                            setModalRef={setModalRef}
                            priority_options={priority_options}
                            rating_options={rating_options}
                            onSelectLeadForConversion={() => {onSelectLeadForConversion(lead.pipeline_id)}}
                        />
                    ))}
                    recordsCount={count}
                    activePage={params.get('page')}
                    onPageChange={onPageChange}
                    recordsName='Lead'
                    tableEmptyMessage={isLeadConnectFilter ? 'No Results found' : undefined}
                emptySubtitleHidden={isLeadConnectFilter}
                onClick={onOpenAddLeadModal}
                    userPermission={USER_PERMISSIONS.LEAD_ADD}
            />
                <QuoteBuilderModal
                    account_id={detailsOfLeadBeingConverted?.account?.id}
                    opportunity_id={detailsOfLeadBeingConverted?.pipeline_id}
                    contact_id={detailsOfLeadBeingConverted?.contact?.id}
                    isLinkedToCustomer={detailsOfLeadBeingConverted?.account?.customer}
                />
            </QuoteBuilderProvider>
            <Modal open={isAddLeadModalOpen} onClose={() => {
                isDirty
                    ? setIsConfirmationOpen(true)
                    : onCloseAddLeadModal();
            }}>
                <AddLeadModal onOpen={() => { return Promise.resolve(); }} onClose={onCloseAddLeadModal} onDirtyChange={(dirty) => setIsDirty(dirty)} />
            </Modal>
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    onCloseAddLeadModal();
                    setIsConfirmationOpen(false);
                    setIsDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
            {selectedLead && <SequenceModal 
                isModalOpen={selectedLead !== null} 
                modalRef={modalRef} 
                onClose={() => {
                    setSelectedLead(null);
                }} 
                contact_id={selectedLead?.contact?.id} 
                refresh={()=>{}}                        
                owner_id={selectedLead?.contact?.owner_id}
            />}
        </React.Fragment>
    );
}

export default LeadsTable;
